<template>
  <section class="four">
    <div class="container">
      <div class="wrap">
        <h3>プロジェクト</h3>
      </div>
      <div class="projects">
        <div class="project" v-for="(project, index) in projects" :key="index">
          <div :data-aos="project.direction" class="card">
            <div class="front">
              <p>{{ project.time }}</p>
              <h4>{{ project.name }}</h4>
              <p>{{ project.description }}</p>
            </div>
            <div class="back">
              <img :src="project.image" />
              <p>{{ project.detail }}</p>
              <a :href="project.link" target="_blank">Click</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ProjectComponentJa",
  data() {
    return {
      projects: [
        {
          name: "Wordpress",
          description: "Block theme and plugin with React",
          time: "2023年4月",
          link: "https://github.com/IzumiKeiki/wordpress",
          detail:
            "「クイズ」と「バナー」、プラグインとして、または新しいテーマのデフォルト機能として実装されたサンプルブロック",
          image: require("../assets/project/Project10.png"),
          direction: "fade-up-right",
        },
        {
          name: "Java",
          description: "CRUD webpage with PostgreSQL",
          time: "2023年3月",
          link: "https://github.com/IzumiKeiki/JavaWeb",
          detail:
            "Java と PostgreSQL を利用するユーザー CRUD (作成、読み取り、更新、および削除) サイト",
          image: require("../assets/project/Project9.png"),
          direction: "fade-up-left",
        },
        {
          name: "Let's have dessert",
          description: "A mini-app with Quasar and Pinia",
          time: "2023年1月",
          link: "https://lets-have-dessert.netlify.app/#/",
          detail:
            "Vue をベースにしたフレームワーク Quasar を使用して実装されたショッピング サイト",
          image: require("../assets/project/Project8.png"),
          direction: "fade-up-left",
        },
        {
          name: "Movie bookmarks",
          description: "A mini-app with React and Movie API",
          time: "2023年1月",
          link: "https://movie-bookmarks.netlify.app/",
          detail:
            "外部 API 経由でデータを取得して表示し、ユーザーの選択内容をローカルにキャッシュするサイト",
          image: require("../assets/project/Project7.png"),
          direction: "fade-up-right",
        },
        {
          name: "Login page",
          description: "A mini-app with Vue and Firebase",
          time: "2022年12月",
          link: "https://login-w-firebase.netlify.app/",
          detail:
            "Firebase 認証 と NoSQL データベースを使用した登録とログインするサイト",
          image: require("../assets/project/Project6.png"),
          direction: "fade-up-left",
        },
        {
          name: "Musical",
          description: "A homepage with Vue",
          time: "2022年12月",
          link: "https://musical-hp.netlify.app/",
          detail:
            "Google フォームを使用したお問い合わせページを含む、複数ページのサイト",
          image: require("../assets/project/Project5.png"),
          direction: "fade-up-right",
        },
        {
          name: "Halloween",
          description: "A mini-game with vanilla Javascript",
          time: "2022年11月",
          link: "https://enter-a-letter.netlify.app/",
          detail: "JavaScriptを使用したクロスデバイス対応の単語当てゲーム",
          image: require("../assets/project/Project4.png"),
          direction: "fade-up-left",
        },
        {
          name: "Flower and Buffterfly",
          description: "A mini-game with vanilla Javascript",
          time: "2022年6月",
          link: "https://flower-and-butterfly.netlify.app/",
          detail: "JavaScript を使用した乱数生成をベースにしたシンプルなゲーム",
          image: require("../assets/project/Project3.png"),
          direction: "fade-up-right",
        },
        // {
        //   name: "Get your dog",
        //   description: "A mini-game with vanilla Javascript",
        //   link: "https://get-your-dog.netlify.app/",
        //   image: require("../assets/project/Project2.png"),
        //   direction: "fade-up-left",
        // },
        {
          name: "Hamster's food",
          description: "A homepage with responsive design",
          time: "2022年6月",
          link: "https://hamster-food.netlify.app/",
          detail:
            "ブートストラップと Javascript を使用して実装された動的な単一ページのサイト",
          image: require("../assets/project/Project1.png"),
          direction: "fade-up-left",
        },
        {
          name: "School",
          description: "A completed homepage by blogspot",
          time: "2018年2月",
          link: "https://obcnet-vn.blogspot.com/",
          detail: "連絡先の詳細と教育情報が含まれる複数ページのウェブサイト",
          image: require("../assets/project/Project0.png"),
          direction: "fade-up-right",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.four {
  background-image: linear-gradient(to top, #fff 94%, #2f9e44 94%);
}

.container {
  max-width: 1280px;
  margin: 0 auto 5rem;
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  h3 {
    border-bottom: 3px solid #1f0d14;
    padding: 0 1.5rem;
    margin: 3rem 9rem;
    font-family: "Noto Serif JP", serif;
    font-size: 3rem;
    color: #1f0d14;
    filter: drop-shadow(3px 5px 2px rgb(0 0 0 / 0.4));
  }

  .projects {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
}

.card {
  margin: 2.5rem;
  width: 15rem;
  height: 23rem;
  position: relative;
  font-family: "Lato", "Noto Serif JP", sans-serif;

  .front,
  .back {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 23rem;
    box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: all 0.8s ease;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    overflow: hidden;
    border-radius: 10px;
  }

  .front {
    justify-content: center;
    background-image: linear-gradient(to top left, #fff 85%, #1f0d14 99%);

    h4,
    p {
      display: block;
      padding: 1.5rem;
      text-align: center;
      color: #1f0d14;
    }

    h4 {
      font-size: 1.5rem;
      line-height: 2.5rem;
    }

    p {
      line-height: 1.5rem;
    }
  }

  .back {
    justify-content: flex-start;
    transform: rotateY(180deg);
    background-image: linear-gradient(to bottom right, #fff, #2f9e44);

    img {
      padding-top: 1rem;
      width: 90%;
      margin: 1rem;
    }

    padding: 0 1.5rem;

    a {
      text-transform: uppercase;
      text-decoration: none;
      margin-top: 1.5rem;
      padding: 1rem 3rem;
      display: inline-block;
      border-radius: 10rem;
      transition: all 0.2s;
      color: #1f0d14;
      background-color: #fff;

      &:hover {
        transform: translateY(-3px);
        box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.2);
      }

      &:active,
      &:focus {
        outline: none;
        transform: translateY(-1px);
      }
    }
  }

  &:hover .front {
    transform: rotateY(-180deg);
  }

  &:hover .back {
    transform: rotateY(0);
  }
}

@for $i from 1 through 10 {
  .project:nth-child(#{$i}) {
    .front {
      animation: flip-front 25s linear #{$i * 0.25 + 3}s infinite;
    }

    .back {
      animation: flip-back 25s linear #{$i * 0.25 + 3}s infinite;
    }

    .card {
      &:hover .front {
        animation: none;
      }

      &:hover .back {
        animation: none;
      }
    }
  }
}

@keyframes flip-front {
  5% {
    transform: rotateY(-180deg);
  }

  40% {
    transform: rotateY(-180deg);
  }

  45% {
    transform: rotateY(0);
  }
}

@keyframes flip-back {
  5% {
    transform: rotateY(0);
  }

  40% {
    transform: rotateY(0);
  }

  45% {
    transform: rotateY(180deg);
  }
}

@media screen and (max-width: 1280px) {
  .four {
    background-image: linear-gradient(to top, #fff 95.5%, #2f9e44 95.5%);
  }
}

@media screen and (max-width: 960px) {
  .four {
    background-image: linear-gradient(to top, #fff 96%, #2f9e44 96%);
  }
}

@media screen and (max-width: 750px) {
  .container {
    align-items: center;

    h3 {
      scale: 0.85;
    }
  }
}

@media screen and (max-width: 700px) {
  .four {
    background-image: linear-gradient(to top, #fff 94%, #2f9e44 94%);
  }

  .container {
    h3 {
      scale: 0.85;
    }
  }

  .card {
    margin: 1.5rem;
    width: 14rem;
    height: 23rem;

    .front,
    .back {
      height: 23rem;
    }
  }
}

@media screen and (max-width: 630px) {
  .container {
    h3 {
      scale: 0.75;
      padding: 0 0.5rem;
      margin: 2.5rem 0.5rem;
    }
  }
}

@media screen and (max-width: 550px) {
  .four {
    background-image: linear-gradient(to top, #fff 97%, #2f9e44 97%);
  }
}
</style>
